import ReactMarkdown from "react-markdown";
import { contentPages } from "@/content/content-pages";
import "./about.css";

export default function AboutPage() {
  return (
    <article className="about-article d8-reveal revealed d8-reveal-delay-1">
      <header className="about-article-header">
        <h1 className="about-article-title">About</h1>
        <p className="about-byline">By Matt Shwed</p>
      </header>

      <div className="about-article-body">
        <ReactMarkdown>{contentPages.about.markdown}</ReactMarkdown>
      </div>
    </article>
  );
}
